import { Injectable, Inject } from '@angular/core';
import { createStore } from 'redux';

import { SessionService, DialogManagerService } from '@src/services';
import { getReducers } from './reducers';
import { getMiddlewares } from './middlewares';

@Injectable({ providedIn: 'root' })
export class Store {
    private store: any;

    constructor(
        @Inject('$http') $http: any,
        @Inject('$translate') $translate: any,
        dialogManagerService: DialogManagerService,
        sessionService: SessionService) {
        const reducers = getReducers();
        const middlewares = getMiddlewares($http, sessionService, $translate, dialogManagerService);
        this.store = createStore(reducers, middlewares);
    }

    public getState() {
        return this.store.getState();
    }

    public dispatch(action: any) {
        action.payload = { ...action.payload };
        return this.store.dispatch(action);
    }

    public subscribe(cb: any) {
        return this.store.subscribe(cb);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/store.ts